import { Injectable } from '@angular/core';
import {ServerNotificationService} from "@catcore/services/server-notification.service";
import {BehaviorSubject, Observable} from "rxjs";

/**
 * Service that centralizes event extraction from server messages. It can be used to avoid having to subscribe to the
 * server message just to filter out certain events.
 */
@Injectable()
export class ServerEventService {

  EVENT_CONFIG_CREATION_FINISHED = 'CONFIG_CREATION_FINISHED';

  MSG_TYPE_PROCESS_START = 0;
  MSG_TYPE_PROCESS_END = 2;

  $serverEvent = new BehaviorSubject<string>(null);

  constructor(private serverNotificationService: ServerNotificationService) {
    serverNotificationService.messages.subscribe((msgs) => {
        msgs.forEach((msg) => {
          this.consumeMessage(msg);
        });
      }
    );
  }

  getServerEvent(): Observable<string> {
    return this.$serverEvent.asObservable();
  }

  private consumeMessage(msg) {
    switch (msg.type) {
      case this.MSG_TYPE_PROCESS_END:
        if (msg.message
          && msg.message.indexOf('config creation') > 0) {
          this.signalEvent(this.EVENT_CONFIG_CREATION_FINISHED);
        }
        break;
      default:
        break;
    }
  }

  private signalEvent(event: string) {
    this.$serverEvent.next(event);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/services/server-event.service.ts